"use client";
import React, { useState, useEffect } from "react";
import GlobalApi from "@/utils/GlobalApi";
import ContentsList from "../../components/ContentsList";
import CategoryFilter from "./CategoryFilter";
import Image from "next/image";
import { motion } from "framer-motion";

function ContentCategory({ params }) {
  const [contentList, setContentList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    async function fetchData() {
      const decodedCategoryName = decodeURIComponent(params.categoryName);
      const { data, meta } = await GlobalApi.getContentsByCategory(
        decodedCategoryName,
        currentPage
      );
      const categoryData = await GlobalApi.getCategoryList();
      setContentList(data);
      setCategoryList(categoryData);
      const selectedCat = categoryData.find(
        (category) => category.attributes.name === decodedCategoryName
      );
      setSelectedCategory(selectedCat);
      setTotalPages(meta.pagination.pageCount);
    }

    fetchData();
  }, [params.categoryName, currentPage]);

  return (
    <>
      <div className="px-5 sm:px-10">
        <CategoryFilter
          categoryList={categoryList}
          selectedCategory={selectedCategory?.attributes.name}
        />
        {selectedCategory && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            transition={{
              duration: 1,
              delay: 0.6,
              type: "spring",
              stiffness: 100,
            }}
            viewport={{ once: true }}
            className="relative shadow-custom border-[#F3F3F3] border bg-white rounded-3xl mt-5 md:mt-0 mb-12 px-10 py-10 md:px-28 md:py-20 flex justify-between items-center"
          >
            {/* Left-side image */}
            <Image
              className="absolute w-[52px] h-[52px] md:w-[92px] md:h-[92px] top-6 left-8 md:top-14 md:left-16 transform -translate-x-10 -translate-y-10"
              src={"/Eclipse2.png"}
              alt="left image"
              width={92}
              height={92}
            />

            {/* Text content */}
            <h1 className="text-[#00477C] text-center md:text-lg lg:text-xl xl:text-[24px] max-w-full font-medium leading-6 md:!leading-10">
              {selectedCategory.attributes.description}
            </h1>

            {/* Right-side image */}
            <Image
              className="absolute w-[80px] h-[40px] md:w-[140px] md:h-[70px] bottom-11 right-12 md:bottom-14 md:right-16 transform translate-x-10 translate-y-10"
              src={"/Eclipse1.png"}
              alt="right image"
              width={140}
              height={70}
            />
          </motion.div>
        )}
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.95 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          transition={{
            duration: 1,
            delay: 1.2,
            type: "spring",
            stiffness: 100,
          }}
          viewport={{ once: true }}
        >
          {contentList.length > 0 ? (
            <ContentsList contentsList={contentList} />
          ) : (
            <div className="flex flex-col items-center justify-center w-full">
              <Image
                src={"/zur.png"}
                width={1000}
                height={1000}
                alt="zur"
                className="w-[220px] h-[220px]"
              />
              <span className="text-center text-[#FFA800] text-base md:text-2xl font-semibold">
                Уучлаарай, энэ хэсэгт мэдээлэл хараахан ороогүй байна.
              </span>
            </div>
          )}
        </motion.div>

        {contentList.length > 0 && totalPages > 1 && (
          <div className="flex justify-center mt-6">
            <div className="flex justify-center mt-6">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="px-4 py-2 border-2 border-[#40A4D8] text-[#40A4D8] rounded-3xl"
              >
                Өмнөх
              </button>
              <span className="mx-4 items-center flex">
                Хуудас {currentPage} | {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className="px-4 py-2  border-2 border-[#40A4D8] text-[#40A4D8] rounded-3xl"
              >
                Дараах
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ContentCategory;
